module.exports = __webpack_public_path__ + "img/[太阳].68272453.svg";